import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Routes from 'apps/portal/routes.erb';
import Button from '@fountain/ui-kit/components/button';
import UjsLink from 'shared/ujs-link';
import AuthLayout from 'apps/portal/layouts/auth';

const propTypes = {
  identity: PropTypes.shape({
    email: PropTypes.string.isRequired,
  }).isRequired,
  isResendingConfirmationEmail: PropTypes.bool.isRequired,
  resendConfirmationEmail: PropTypes.func.isRequired,
  returnTo: PropTypes.string,
};

const defaultProps = {
  returnTo: undefined,
};

export default function PortalEmailConfirmation({
  identity,
  isResendingConfirmationEmail,
  resendConfirmationEmail,
  returnTo,
}) {
  return (
    <AuthLayout
      footerText={
        <Fragment>
          If you do not receive a confirmation email in a few minutes, check your spam/junk folder or
          {' '}
          <Button
            disabled={isResendingConfirmationEmail}
            onClick={resendConfirmationEmail}
            theme="link"
          >
            click here to re-send
          </Button>.
        </Fragment>
      }
      headerButtons={(
        <UjsLink href={Routes.destroy_identity_session_path()} method="delete">Sign Out</UjsLink>
      )}
      title="Confirm your email"
    >
      <p>
        We just sent an email to <b>{identity.email}</b>
      </p>
      <p>
        Please check your inbox for a confirmation email.
        <br />
        Click the link in the email to confirm your email address.
      </p>
      {returnTo && <Button href={returnTo}>Back to Application</Button>}
    </AuthLayout>
  );
}
PortalEmailConfirmation.propTypes = propTypes;
PortalEmailConfirmation.defaultProps = defaultProps;
